import { render, staticRenderFns } from "./ApprovalInsertTransactionDetail.vue?vue&type=template&id=61f67cbe"
import script from "./ApprovalInsertTransactionDetail.vue?vue&type=script&lang=js"
export * from "./ApprovalInsertTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./ApprovalInsertTransactionDetail.vue?vue&type=style&index=0&id=61f67cbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports